import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

export const MIN_AGE = 18;

export const T_PREFIX = 'products-fe.containers.applicant';

const cyPrefix = 'containers_applicant';

const ids = addCyPrefixToIDs(cyPrefix, {
  INPUT_APPLICANT_CHECKBOX: 'INPUT_APPLICANT_CHECKBOX',
  LINK_ADD_APPLICANT: 'LINK_ADD_APPLICANT',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
/** @type {ids} */
export const CY_APPLICANT_CONTAINER_IDS = ids;
